import React, { useEffect, useMemo, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { map } from "lodash";
import Select from "react-select";
import InputMask from "react-input-mask";
import { Editor } from "@tinymce/tinymce-react";

import Config from "config";
import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  Table,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";

import HmfFactureEdit from "./HmfFactureEdit";

const FactureEdit = () => {
  const api = Config.backOffice.apiName;
  const backUrl = Config.backOffice.url;
  let { id } = useParams();
  const editorRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("auth_token_" + api);
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);
  const [wait, setWait] = useState(1000);
  const toggleModal = () => setModal(!modal);
  const [factureData, setFactureData] = useState([]);
  const colStyle = {
    width: "20em", // Largeur fixe pour la première colonne
    whiteSpace: "wrap", // Empêche le texte de revenir à la ligne
    display: "inline-block", // Permet de conserver le texte sur une seule ligne
    color: "#7f7f7f",
    verticalAlign: "middle", // Alignement vertical au centre pour le texte
    display: "flex", // Utilisation de flexbox pour aligner les éléments horizontalement
    alignItems: "center", // Centrage vertical du texte et de l'input
  };
  const layout = localStorage.getItem("layoutMode");

  const styles = (hasError) => ({
    container: (provided) => ({
      ...provided,
      overflow: "visible",
      fontSize: "0.7109375rem",
    }),
    menu: (provided) => ({
      ...provided,
      textAlign: "left",
      overflow: "visible",
      backgroundColor: layout === "dark" ? "#2A3042" : "#fff", // Couleur de fond selon le mode
      color: layout === "dark" ? "#fff" : "#000", // Couleur du texte selon le mode
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#555B21"
        : layout === "dark"
        ? "#444"
        : "transparent", // Ajustement du background selon le mode
      color: state.isSelected ? "white" : layout === "dark" ? "#fff" : "black", // Ajustement de la couleur selon le mode
      textAlign: "left",
      fontWeight: "normal",
      paddingLeft: 40,
      paddingTop: 10,
    }),
    groupHeading: (provided) => ({
      ...provided,
      fontWeight: "bold",
      fontSize: "15px",
      color: layout === "dark" ? "white" : "black", // Couleur selon le mode
      textAlign: "left",
    }),

    control: (provided, state) => ({
      ...provided,
      //height: "1.69125rem",
      minHeight: "1.69125rem",
      border: state.isFocused
        ? hasError
          ? "1px solid red"
          : layout === "dark"
          ? "1px solid #555"
          : "1px solid #ccc"
        : hasError
        ? "1px solid red"
        : layout === "dark"
        ? "1px solid #555"
        : "1px solid #ccc", // Ajustement de la bordure selon le mode
      backgroundColor: layout === "dark" ? "#2A3042" : "#fff", // Background du contrôle selon le mode
      boxShadow: "none",
      "&:hover": {
        border: hasError
          ? "1px solid red"
          : layout === "dark"
          ? "1px solid #555"
          : "1px solid #ccc", // Ajustement de la bordure au survol selon le mode
      },
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "2px",
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: "2px",
    }),
  });
  //meta title
  const [activeTab, setActiveTab] = useState("details"); // État pour contrôler l'affichage

  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };
  document.title = "Facture | Edit";
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    const navStyleClient = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
      textAlign: "left",
    };

    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={navStyle}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            onClick={() => handleTabClick("details")}
          >
            {!loading ? (
              "Edit facture"
            ) : (
              <span
                className="placeholder col-3"
                style={{ height: "1em" }}
              ></span>
            )}
          </NavLink>
        </NavItem>
      </Nav>
    );
  };
  /*************************   Facturation  *******************************/

  const [selectedFacturation, setSelectedFaturation] = useState("");

  /*************************   END Facturation *******************************/
  /*************************   Forcer le mode de paiment  *******************************/
  const [modeP, setModeP] = useState({ data: [] });
  const [selectedModeP, setSelectedModeP] = useState("");
  const handleModePChange = (e) => {
    setSelectedModeP(e);
  };
  const getModePaiement = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/fx_paiements/paiement_modes`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((pme) => {
          setModeP(pme);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderModePOptions = () => {
    return [
      {
        options: modeP.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END Mode P *******************************/

  /*************************   extra  *******************************/
  const [code, setCodeData] = useState({ data: [] });
  const [selectedExtra, setSelectedExtra] = useState("");
  const handleExtraChange = (e) => {
    setSelectedExtra(e);
  };

  /*************************   END Extra *******************************/
  // Commentaire
  const [selectedCommentaire, setSelectedCommentaire] = useState("");
  const handleCommentaireChange = (e) => {
    setSelectedCommentaire(e.target.value);
  };
  console.log(selectedCommentaire);
  /*************************   Statut  *******************************/
  const [statut, setStatutData] = useState({ data: [] });
  const [selectedStatut, setSelectedStatut] = useState("");
  const handleStatutChange = (e) => {
    setSelectedStatut(e);
  };
  const getStatut = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/fx_paiements/paiement_statuts`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((pme) => {
          setStatutData(pme);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderStatutOptions = () => {
    return [
      {
        options: statut.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END Statut *******************************/

  // Base calcul
  const [baseCalcul, setBaseCalcul] = useState({ data: [] });
  const [selectedExploitant, setSelectedExploitant] = useState();
  const handleExploitantChange = (e) => {
    setSelectedExploitant(e);
  };
  const getBaseCalcul = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/fx_paiements/bases_de_calculs  `, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((pme) => {
          setBaseCalcul(pme);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderBaseOptions = () => {
    return [
      <option key="" value=""></option>,
      ...baseCalcul.data.map((dataItem) => (
        <option key={dataItem.id} value={dataItem.id}>
          {dataItem.label}
        </option>
      )),
    ];
  };

  // Date Paiement
  const [selectedDateP, setSelectedDateP] = useState("");
  const handleDatePChange = (e) => {
    setSelectedDateP(e.target.value);
  };
  // Date de facture
  const [selectedDateFacture, setSelectedDateFacture] = useState("");
  const handleDateFactureChange = (e) => {
    setSelectedDateFacture(e.target.value);
  };
  // Date Echeancier
  const [selectedDateEcheancier, setSelectedDateEcheancier] = useState("");
  const handleDateEcheancierChange = (e) => {
    setSelectedDateEcheancier(e.target.value);
  };
  // Date Facturation
  const [selectedDateFacturation, setSelectedDateFacturation] = useState("");
  const handleDateFacturationChange = (e) => {
    setSelectedDateFacturation(e.target.value);
  };
  // Date fin Facturation
  const [selectedDateFinFacturation, setSelectedDateFinFacturation] =
    useState("");
  const handleDateFinFacturationChange = (e) => {
    setSelectedDateFinFacturation(e.target.value);
  };
  // Facture Envoyé
  const [selectedFactureEnv, setSelectedFactureEnv] = useState("");
  const handleFactureEnvChange = (e) => {
    setSelectedFactureEnv(e);
  };
  // Facture Archive
  const [selectedFactureArchive, setSelectedFactureArchive] = useState("");
  const handleFactureArchiveChange = (event) => {
    const newFile = event.target.files[0]; // Récupère le nouveau fichier
    if (newFile) {
      setSelectedFactureArchive(newFile);
    } else {
      setSelectedFactureArchive(null);
      console.log("Aucun fichier sélectionné");
    }
  };
  // Augmentation
  const [selectedAugmentation, setSelectedAugmentation] = useState("");
  const handleAugmentationChange = (e) => {
    setSelectedAugmentation(e.target.value);
  };

  // Indexation

  const [selectedIndexation, setSelectedIndexation] = useState();
  const handleIndexationChange = (e) => {
    setSelectedIndexation(e);
  };

  const OuiNon = {
    data: [
      { id: 1, label: "Oui" },
      { id: 2, label: "Non" },
    ],
  };
  const renderYesNoOptions = () => {
    return [
      <option key="" value=""></option>,
      ...OuiNon.data.map((dataItem) => (
        <option key={dataItem.id} value={dataItem.id}>
          {dataItem.label}
        </option>
      )),
    ];
  };
  const renderOuiNonOptions = () => {
    return [
      {
        options: OuiNon.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /******************************* HMF ProduitFacture *******************************************/
  const [formProduitFacture, setFormProduitFacture] = useState([]);
  //   console.log(formProduitFacture);
  const onAddFormProduitFacture = () => {
    const modifiedProduitFacture = [...formProduitFacture];
    // console.log(modifiedProduitFacture);
    modifiedProduitFacture.push({
      index: modifiedProduitFacture.length + 1,
      id: null,
      fx_base_de_calcul_id: null,
      produit: null,
      quantite_consommee: null,
      quantite: null,
      prix_unitaire_ht: null,
      prix_de_vente_ht: null,
      taux_de_tva: null,
      prix_de_vente_ttc: null,
      debut: null,
      fin: null,
      reel: null,
      addition: null,
      extra: null,
    });
    // console.log(modifiedProduitFacture);
    setFormProduitFacture(modifiedProduitFacture);
  };

  const onDeleteFormProduitFacture = (id) => {
    var modifiedProduitFacture = [...formProduitFacture];
    modifiedProduitFacture = modifiedProduitFacture.filter(
      (x) => x["index"] !== id
    );
    setFormProduitFacture(modifiedProduitFacture);
  };
  const handleInputProduitFactureChange = (index, field, value) => {
    const modifiedProduitFacture = formProduitFacture.map(
      (donnesProduitFacture) => {
        if (donnesProduitFacture.index === index) {
          return {
            ...donnesProduitFacture,
            [field]: value,
          };
        }
        return donnesProduitFacture;
      }
    );

    setFormProduitFacture(modifiedProduitFacture);
  };
  /******************************* END HMF ProduitFacture *******************************************/
  /******************************* HMF Consommation réelle (à échoir) *******************************************/
  const [formConsommationreelle, setFormConsommationreelle] = useState([]);
  //   console.log(formConsommationreelle);
  const onAddFormConsommationreelle = () => {
    const modifiedConsommationreelle = [...formConsommationreelle];
    console.log(modifiedConsommationreelle);
    modifiedConsommationreelle.push({
      index: modifiedConsommationreelle.length + 1,
      id: null,
      fx_base_de_calcul_id: null,
      produit: "Remise",
      quantite_consommee: null,
      quantite: null,
      prix_unitaire_ht: null,
      prix_de_vente_ht: null,
      taux_de_tva: 20,
      prix_de_vente_ttc: null,
      debut: null,
      fin: null,
      reel: 1,
      addition: 1,
      extra: 2,
    });
    // console.log(modifiedConsommationreelle);
    setFormConsommationreelle(modifiedConsommationreelle);
  };

  const onDeleteFormConsommationreelle = (id) => {
    var modifiedConsommationreelle = [...formConsommationreelle];
    modifiedConsommationreelle = modifiedConsommationreelle.filter(
      (x) => x["index"] !== id
    );
    setFormConsommationreelle(modifiedConsommationreelle);
  };
  const handleInputConsommationreelleChange = (index, field, value) => {
    const modifiedConsommationreelle = formConsommationreelle.map(
      (donnesConsommationreelle) => {
        if (donnesConsommationreelle.index === index) {
          return {
            ...donnesConsommationreelle,
            [field]: value,
          };
        }
        return donnesConsommationreelle;
      }
    );

    setFormConsommationreelle(modifiedConsommationreelle);
  };
  /******************************* END HMF Consommationreelle *******************************************/
  /******************************* HMF Estimation précédente (à échoir) *******************************************/
  const [formEstimationPrecedente, setFormEstimationPrecedente] = useState([]);
  //   console.log(formEstimationPrecedente);
  const onAddFormEstimationPrecedente = () => {
    const modifiedEstimationPrecedente = [...formEstimationPrecedente];
    // console.log(modifiedEstimationPrecedente);
    modifiedEstimationPrecedente.push({
      index: modifiedEstimationPrecedente.length + 1,
      id: null,
      fx_base_de_calcul_id: null,
      produit: "Remise",
      quantite_consommee: null,
      quantite: null,
      prix_unitaire_ht: null,
      prix_de_vente_ht: null,
      taux_de_tva: 20,
      prix_de_vente_ttc: null,
      debut: null,
      fin: null,
      reel: 2,
      addition: 2,
      extra: 2,
    });
    // console.log(modifiedEstimationPrecedente);
    setFormEstimationPrecedente(modifiedEstimationPrecedente);
  };

  const onDeleteFormEstimationPrecedente = (id) => {
    var modifiedEstimationPrecedente = [...formEstimationPrecedente];
    modifiedEstimationPrecedente = modifiedEstimationPrecedente.filter(
      (x) => x["index"] !== id
    );
    setFormEstimationPrecedente(modifiedEstimationPrecedente);
  };
  const handleInputEstimationPrecedenteChange = (index, field, value) => {
    const modifiedEstimationPrecedente = formEstimationPrecedente.map(
      (donnesEstimationPrecedente) => {
        if (donnesEstimationPrecedente.index === index) {
          return {
            ...donnesEstimationPrecedente,
            [field]: value,
          };
        }
        return donnesEstimationPrecedente;
      }
    );

    setFormEstimationPrecedente(modifiedEstimationPrecedente);
  };
  /******************************* END HMF EstimationPrecedente *******************************************/
  /******************************* HMF Estimation suivante (à échoir) *******************************************/
  const [formEstimationSuivante, setFormEstimationSuivante] = useState([]);
  //   console.log(formEstimationSuivante);
  const onAddFormEstimationSuivante = () => {
    const modifiedEstimationSuivante = [...formEstimationSuivante];
    // console.log(modifiedEstimationSuivante);
    modifiedEstimationSuivante.push({
      index: modifiedEstimationSuivante.length + 1,
      id: null,
      fx_base_de_calcul_id: null,
      produit: "Remise",
      quantite_consommee: null,
      quantite: null,
      prix_unitaire_ht: null,
      prix_de_vente_ht: null,
      taux_de_tva: 20,
      prix_de_vente_ttc: null,
      debut: null,
      fin: null,
      reel: 2,
      addition: 1,
      extra: 2,
    });
    // console.log(modifiedEstimationSuivante);
    setFormEstimationSuivante(modifiedEstimationSuivante);
  };

  const onDeleteFormEstimationSuivante = (id) => {
    var modifiedEstimationSuivante = [...formEstimationSuivante];
    modifiedEstimationSuivante = modifiedEstimationSuivante.filter(
      (x) => x["index"] !== id
    );
    setFormEstimationSuivante(modifiedEstimationSuivante);
  };
  const handleInputEstimationSuivanteChange = (index, field, value) => {
    const modifiedEstimationSuivante = formEstimationSuivante.map(
      (donnesEstimationSuivante) => {
        if (donnesEstimationSuivante.index === index) {
          return {
            ...donnesEstimationSuivante,
            [field]: value,
          };
        }
        return donnesEstimationSuivante;
      }
    );

    setFormEstimationSuivante(modifiedEstimationSuivante);
  };
  /******************************* END HMF EstimationSuivante *******************************************/
  /******************************* HMF Extra *******************************************/
  const [formExtra, setFormExtra] = useState([]);
  //   console.log(formExtra);
  const onAddFormExtra = () => {
    const modifiedExtra = [...formExtra];
    // console.log(modifiedExtra);
    modifiedExtra.push({
      index: modifiedExtra.length + 1,
      id: null,
      fx_base_de_calcul_id: null,
      produit: "Remise",
      quantite_consommee: null,
      quantite: null,
      prix_unitaire_ht: null,
      prix_de_vente_ht: null,
      taux_de_tva: 20,
      prix_de_vente_ttc: null,
      debut: null,
      fin: null,
      reel: null,
      addition: null,
      extra: 1,
    });
    // console.log(modifiedExtra);
    setFormExtra(modifiedExtra);
  };

  const onDeleteFormExtra = (id) => {
    var modifiedExtra = [...formExtra];
    modifiedExtra = modifiedExtra.filter((x) => x["index"] !== id);
    setFormExtra(modifiedExtra);
  };
  const handleInputExtraChange = (index, field, value) => {
    const modifiedExtra = formExtra.map((donnesExtra) => {
      if (donnesExtra.index === index) {
        return {
          ...donnesExtra,
          [field]: value,
        };
      }
      return donnesExtra;
    });

    setFormExtra(modifiedExtra);
  };
  /******************************* END HMF Extra *******************************************/

  const handleNavigate = () => {
    localStorage.setItem("key", true);
    localStorage.setItem("lastId", id);
    navigate(-1);
  };
  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("id", id);
      formData.append("fx_facturation_id", selectedFacturation?.value || "");
      formData.append("date_initial", selectedDateEcheancier);
      formData.append("date", selectedDateFacture);
      formData.append("paiement_statut_value", selectedStatut?.value || "");
      formData.append("paiement_mode_value", selectedModeP?.value || "");
      formData.append("paiement_date_time", selectedDateP);
      formData.append("debut_de_facturation", selectedDateFacturation);
      formData.append("fin_de_facturation", selectedDateFinFacturation);
      formData.append("indexation", selectedIndexation?.value || "");
      formData.append("augmentation", selectedAugmentation || "");
      formData.append("facture_envoyee", selectedFactureEnv?.value || "");
      formData.append("facture_archive", selectedFactureArchive);
      formData.append("extra_only", selectedExtra?.value || "");
      formData.append("extra_commentaires", selectedCommentaire);
      //   formData.append(
      //     "hmf_produits_factures",
      //     JSON.stringify(
      //       formProduitFacture.map((obj) => {
      //         const { index, ...rest } = obj;
      //         return rest;
      //       })
      //     )
      //   );
      formData.append(
        "hmf_conso_reelle",
        JSON.stringify(
          formConsommationreelle.map((obj) => {
            const { index, ...rest } = obj;
            return rest;
          })
        )
      );
      formData.append(
        "hmf_next_estimated",
        JSON.stringify(
          formEstimationSuivante.map((obj) => {
            const { index, ...rest } = obj;
            return rest;
          })
        )
      );
      formData.append(
        "hmf_produits_factures_extra",
        JSON.stringify(
          formExtra.map((obj) => {
            const { index, ...rest } = obj;
            return rest;
          })
        )
      );
      formData.append(
        "hmf_previous_estimated",
        JSON.stringify(
          formEstimationPrecedente.map((obj) => {
            const { index, ...rest } = obj;
            return rest;
          })
        )
      );
      const response = await fetch(
        `https://www.fluxod.com/${api}/fx_paiements/${id}`,
        {
          method: "PATCH",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
        }
      );

      if (response.ok) {
        console.log("PATCH request successful");
        handleNavigate();
      } else {
        console.error("PATCH request failed");
        const responseData = await response.json();

        if (responseData && responseData.fx_paiement_validation) {
          // Si le champ "contact_validation" est présent dans la réponse JSON
          const errors = responseData?.fx_paiement_validation;
          errors.forEach((error) => {
            toast.error(error);
          });
        } else {
          toast.error("Une erreur s'est produite");
        }
      }
    } catch (error) {
      console.error("An error occurred", error);
      toast.error("Une erreur s'est produite");
    }
  };

  useEffect(() => {
    setLoading(true);
    const getData = async () => {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/fx_paiements/${id}/edit`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.status === 403) {
          navigate(`${backUrl}/forbidden`);
        }
        if (response.status === 500) {
          navigate(`${backUrl}/error`);
        }
        if (response.status === 203) {
          navigate(`${backUrl}/error404`);
        }
        if (response.status === 401) {
          localStorage.removeItem("auth_token_" + api);
          localStorage.removeItem("authUser_" + api);
          localStorage.removeItem("sideBar_" + api);
          navigate(`${backUrl}/login`);
          window.location.reload(false);
        }
        // if (!response.ok) {
        //   localStorage.removeItem("auth_token_"+api);
        //   localStorage.removeItem("authUser_"+api);
        //   localStorage.removeItem("sideBar_"+api);
        //   history("/backoffice_test/login");
        //   window.location.reload(false);
        //   throw new Error(`Request failed with status: ${response.status}`);
        // }

        const data = await response.json();
        setFactureData(data);
        setSelectedFaturation(
          data?.detail_fx_paiement?.["Informations"]?.Facturation
        );
        setSelectedStatut(data?.detail_fx_paiement?.Informations?.Statut);
        setSelectedDateEcheancier(
          data?.detail_fx_paiement?.Informations?.["Date échéancier"]
        );
        setSelectedDateFacture(
          data?.detail_fx_paiement?.Informations?.["Date de facture"]
        );
        setSelectedModeP(
          data?.detail_fx_paiement?.Informations?.["Forcer le mode de paiement"]
        );
        setSelectedDateP(
          data?.detail_fx_paiement?.Informations?.["Forcer la date de paiement"]
        );
        setSelectedDateFacturation(
          data?.detail_fx_paiement?.Informations?.["Début de facturation"]
        );
        setSelectedDateFinFacturation(
          data?.detail_fx_paiement?.Informations?.["Fin de facturation"]
        );
        setSelectedIndexation(
          data?.detail_fx_paiement?.Informations?.Indexation
        );
        setSelectedAugmentation(
          data?.detail_fx_paiement?.Informations?.Augmentation
        );
        setSelectedFactureEnv(
          data?.detail_fx_paiement?.Informations?.["Facture envoyée"]
        );
        setSelectedFactureArchive(
          data?.detail_fx_paiement?.Informations?.["Facture archive"]
        );
        setFormProduitFacture(
          data?.detail_fx_paiement?.["Produits facturés (échu)"]?.[
            "Produits facturés"
          ].data
        );
        setFormConsommationreelle(
          data?.detail_fx_paiement?.["Consommation réelle (à échoir)"]?.[
            "Consommation réelle"
          ].data
        );
        setFormEstimationPrecedente(
          data?.detail_fx_paiement?.["Estimation précédente (à échoir)"]?.[
            "Estimation précédente"
          ].data
        );
        setFormEstimationSuivante(
          data?.detail_fx_paiement?.["Estimation suivante (à échoir)"]?.[
            "Estimation suivante"
          ].data
        );
        setFormExtra(data?.detail_fx_paiement?.["Extra"]?.["Extra"].data);
        setSelectedExtra(data?.detail_fx_paiement?.["Extra"]?.["Extra only"]);
        setSelectedCommentaire(
          data?.detail_fx_paiement?.["Extra"]?.["Commentaires"]
        );
        setWait(0);
      } catch (error) {
        // Handle any other errors that might occur during the fetch
        console.error("Error fetching data:", error.message);
      }
    };

    const fetchData = async () => {
      try {
        await getData();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
    if (localStorage.getItem("key") === "true") {
      toast.success("Mise à jour réussie");
      localStorage.setItem("key", "false");
    }
  }, []);
  useEffect(() => {
    if (wait === 0) {
      setLoading(false);
    }
  }, [wait]);
  useEffect(() => {
    if (!loading) {
      getStatut();
      getModePaiement();
      getBaseCalcul();
    }
  }, [loading]);

  let linkState = { active: "" };

  if (activeTab == "details") {
    linkState.active = "details";
  } else if (activeTab == "contact") {
    linkState.active = "contact";
  } else {
    linkState.active = "details";
  }

  return (
    <React.Fragment>
      <div className="page-content" style={{ fontFamily: "sans-serif" }}>
        <div className="container-fluid">
          <Row>
            <Col lg="12">
              <Card>
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center">
                    <h5
                      className="mb-0 card-title flex-grow-1"
                      style={{ fontWeight: "bold", display: "flex" }}
                    >
                      {!loading ? (
                        <>
                          <Link
                            to={`${backUrl}/fx_paiements/list`}
                            style={{
                              color: "#555B21",
                              textDecoration: "underline !important",
                            }}
                          >
                            Facture
                          </Link>{" "}
                        </>
                      ) : (
                        <span
                          className="placeholder col-3"
                          style={{ height: "1em" }}
                        ></span>
                      )}
                      <i className="bx bx-caret-right"></i>{" "}
                      {!loading ? (
                        factureData.sil
                      ) : (
                        <>
                          <span
                            className="placeholder col-3"
                            style={{ height: "1em" }}
                          ></span>
                        </>
                      )}
                    </h5>
                  </div>

                  <div className="d-flex justify-content-end">
                    <div className="d-flex align-items-end">
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={handleSubmit}
                      >
                        <i className="bx bx-send"></i> Valider
                      </button>
                      &nbsp; &nbsp;
                      <Link
                        to="#"
                        onClick={() => navigate(-1)}
                        className="btn btn-sm btn-soft-secondary "
                        style={{ width: "88.43px" }}
                      >
                        <i className="bx bx-arrow-back"></i> Annuler
                      </Link>
                    </div>
                  </div>
                </CardBody>
                {CustomNavTabs()}
                <CardBody>
                  {activeTab === "details" && (
                    <div>
                      {!loading ? (
                        <>
                          <Row>
                            <Col sm="12">
                              {factureData?.detail_fx_paiement?.[
                                "Informations"
                              ] ? (
                                <Card className="mb-4">
                                  <CardTitle
                                    tag="h5"
                                    style={{ paddingLeft: "10px" }}
                                  >
                                    Informations
                                  </CardTitle>
                                  <CardBody>
                                    {Object.entries(
                                      factureData?.detail_fx_paiement?.[
                                        "Informations"
                                      ]
                                    ).map(([key, value], index) => (
                                      <Row className="mb-2" key={index}>
                                        {key == "Facturation" ? (
                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i
                                                style={{
                                                  color: "#9d9c9c",
                                                }}
                                              >
                                                <span>{key} :</span>
                                              </i>
                                            </Col>
                                            <Col className="col-8">
                                              <Select
                                                defaultValue={
                                                  selectedFacturation
                                                }
                                                isClearable={true}
                                                className="select2"
                                                isDisabled
                                              />
                                              {/* {selectedPme === null ? (
                                                <div
                                                  style={{
                                                    color: "red",
                                                    whiteSpace: "nowrap",
                                                  }}
                                                >
                                                  PME ne peut pas être vide
                                                </div>
                                              ) : (
                                                ""
                                              )} */}
                                            </Col>
                                          </>
                                        ) : key ==
                                          "Forcer le mode de paiement" ? (
                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i
                                                style={{
                                                  color: "#9d9c9c",
                                                }}
                                              >
                                                <span>{key}:</span>
                                              </i>
                                            </Col>
                                            <Col className="col-8">
                                              <Select
                                                defaultValue={selectedModeP}
                                                onChange={handleModePChange}
                                                options={renderModePOptions()}
                                                isClearable={true}
                                                className="select2"
                                                styles={styles(false)}
                                              />
                                            </Col>
                                          </>
                                        ) : key ==
                                          "Forcer la date de paiement" ? (
                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i
                                                style={{
                                                  color: "#9d9c9c",
                                                }}
                                              >
                                                <span>{key}:</span>
                                              </i>
                                            </Col>
                                            <Col className="col-8">
                                              <InputMask
                                                mask="99/99/9999"
                                                value={selectedDateP}
                                                className="form-control form-control-sm input-color"
                                                onChange={(dateString) => {
                                                  setSelectedDateP(
                                                    dateString.target.value
                                                  );
                                                }}
                                              />
                                            </Col>
                                          </>
                                        ) : key == "Début de facturation" ? (
                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i
                                                style={{
                                                  color: "#9d9c9c",
                                                }}
                                              >
                                                <span>{key}:</span>
                                              </i>
                                            </Col>
                                            <Col className="col-8">
                                              <InputMask
                                                mask="99/99/9999"
                                                value={selectedDateFacturation}
                                                className="form-control form-control-sm input-color"
                                                onChange={(dateString) => {
                                                  setSelectedDateFacturation(
                                                    dateString.target.value
                                                  );
                                                }}
                                                disabled
                                              />
                                            </Col>
                                          </>
                                        ) : key == "Fin de facturation" ? (
                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i
                                                style={{
                                                  color: "#9d9c9c",
                                                }}
                                              >
                                                <span>{key}:</span>
                                              </i>
                                            </Col>
                                            <Col className="col-8">
                                              <InputMask
                                                mask="99/99/9999"
                                                value={
                                                  selectedDateFinFacturation
                                                }
                                                className="form-control form-control-sm input-color"
                                                onChange={(dateString) => {
                                                  setSelectedDateFinFacturation(
                                                    dateString.target.value
                                                  );
                                                }}
                                                disabled
                                              />
                                            </Col>
                                          </>
                                        ) : key == "Statut" ? (
                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i
                                                style={{
                                                  color: "#9d9c9c",
                                                }}
                                              >
                                                <span>{key}:</span>
                                              </i>
                                            </Col>
                                            <Col className="col-8">
                                              <Select
                                                defaultValue={selectedStatut}
                                                onChange={handleStatutChange}
                                                options={renderStatutOptions()}
                                                isClearable={true}
                                                className="select2"
                                                styles={styles(false)}
                                              />
                                              {/* {selectedStatut === null ? (
                                                <div
                                                  style={{
                                                    color: "red",
                                                    whiteSpace: "nowrap",
                                                  }}
                                                >
                                                  Statut ne peut pas être vide
                                                </div>
                                              ) : (
                                                ""
                                              )} */}
                                            </Col>
                                          </>
                                        ) : key == "Facture envoyée" ? (
                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i
                                                style={{
                                                  color: "#9d9c9c",
                                                }}
                                              >
                                                <span>{key}:</span>
                                              </i>
                                            </Col>
                                            <Col className="col-8">
                                              <Select
                                                defaultValue={
                                                  selectedFactureEnv
                                                }
                                                onChange={
                                                  handleFactureEnvChange
                                                }
                                                options={renderOuiNonOptions()}
                                                isClearable={true}
                                                className="select2"
                                                styles={styles(false)}
                                              />
                                            </Col>
                                          </>
                                        ) : key === "Facture archive" ? (
                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "8em",

                                                    whiteSpace: "wrap",
                                                  }}
                                                >
                                                  {key} :
                                                </span>
                                              </i>
                                            </Col>
                                            <Col className="mb-2 col-md-8">
                                              {value != null ? (
                                                <a href={value} download>
                                                  Voir
                                                </a>
                                              ) : null}
                                              <input
                                                type="file"
                                                onChange={
                                                  handleFactureArchiveChange
                                                }
                                                className="form-control form-control-sm"
                                              />
                                            </Col>
                                          </>
                                        ) : key == "Indexation" ? (
                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i
                                                style={{
                                                  color: "#9d9c9c",
                                                }}
                                              >
                                                <span>{key}:</span>
                                              </i>
                                            </Col>
                                            <Col className="col-8">
                                              <Select
                                                defaultValue={
                                                  selectedIndexation
                                                }
                                                onChange={
                                                  handleIndexationChange
                                                }
                                                options={renderOuiNonOptions()}
                                                isClearable={true}
                                                className="select2"
                                                styles={styles(false)}
                                              />
                                            </Col>
                                          </>
                                        ) : key == "Date échéancier" ? (
                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i
                                                style={{
                                                  color: "#9d9c9c",
                                                }}
                                              >
                                                <span>{key}:</span>
                                              </i>
                                            </Col>
                                            <Col className="col-8">
                                              <InputMask
                                                mask="99/99/9999"
                                                value={selectedDateEcheancier}
                                                className="form-control form-control-sm input-color"
                                                onChange={(dateString) => {
                                                  setSelectedDateEcheancier(
                                                    dateString.target.value
                                                  );
                                                }}
                                              />
                                            </Col>
                                          </>
                                        ) : key == "Date de facture" ? (
                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i
                                                style={{
                                                  color: "#9d9c9c",
                                                }}
                                              >
                                                <span>{key}:</span>
                                              </i>
                                            </Col>
                                            <Col className="col-8">
                                              <InputMask
                                                mask="99/99/9999"
                                                value={selectedDateFacture}
                                                className="form-control form-control-sm input-color"
                                                onChange={(dateString) => {
                                                  setSelectedDateFacture(
                                                    dateString.target.value
                                                  );
                                                }}
                                              />
                                            </Col>
                                          </>
                                        ) : key == "Augmentation" ? (
                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i
                                                style={{
                                                  color: "#9d9c9c",
                                                }}
                                              >
                                                <span>{key} :</span>
                                              </i>
                                            </Col>
                                            <Col className="col-8">
                                              <input
                                                className="form-control form-control-sm"
                                                defaultValue={
                                                  selectedAugmentation
                                                }
                                                required
                                                onChange={
                                                  handleAugmentationChange
                                                }
                                              />
                                            </Col>
                                          </>
                                        ) : null}
                                      </Row>
                                    ))}
                                  </CardBody>
                                </Card>
                              ) : null}

                              {factureData?.detail_fx_paiement?.[
                                "Produits facturés (échu)"
                              ] ? (
                                <HmfFactureEdit
                                  title={"Produits facturés (échu)"}
                                  data={
                                    factureData?.detail_fx_paiement?.[
                                      "Produits facturés (échu)"
                                    ]?.["Produits facturés"]
                                  }
                                  form={formProduitFacture}
                                  onAddForm={onAddFormProduitFacture}
                                  onDeleteForm={onDeleteFormProduitFacture}
                                  handleInputChange={
                                    handleInputProduitFactureChange
                                  }
                                  renderBaseOptions={renderBaseOptions()}
                                  renderOuiNonOptions={renderYesNoOptions()}
                                />
                              ) : null}
                              {factureData?.detail_fx_paiement?.[
                                "Consommation réelle (à échoir)"
                              ] ? (
                                <HmfFactureEdit
                                  title={"Consommation réelle (à échoir)"}
                                  data={
                                    factureData?.detail_fx_paiement?.[
                                      "Consommation réelle (à échoir)"
                                    ]?.["Consommation réelle"]
                                  }
                                  form={formConsommationreelle}
                                  onAddForm={onAddFormConsommationreelle}
                                  onDeleteForm={onDeleteFormConsommationreelle}
                                  handleInputChange={
                                    handleInputConsommationreelleChange
                                  }
                                  renderBaseOptions={renderBaseOptions()}
                                  renderOuiNonOptions={renderYesNoOptions()}
                                />
                              ) : null}
                              {factureData?.detail_fx_paiement?.[
                                "Estimation précédente (à échoir)"
                              ] ? (
                                <HmfFactureEdit
                                  title={"Estimation précédente (à échoir)"}
                                  data={
                                    factureData?.detail_fx_paiement?.[
                                      "Estimation précédente (à échoir)"
                                    ]?.["Estimation précédente"]
                                  }
                                  form={formEstimationPrecedente}
                                  onAddForm={onAddFormEstimationPrecedente}
                                  onDeleteForm={
                                    onDeleteFormEstimationPrecedente
                                  }
                                  handleInputChange={
                                    handleInputEstimationPrecedenteChange
                                  }
                                  renderBaseOptions={renderBaseOptions()}
                                  renderOuiNonOptions={renderYesNoOptions()}
                                />
                              ) : null}
                              {factureData?.detail_fx_paiement?.[
                                "Estimation précédente (à échoir)"
                              ] ? (
                                <HmfFactureEdit
                                  title={"Estimation suivante (à échoir)"}
                                  data={
                                    factureData?.detail_fx_paiement?.[
                                      "Estimation suivante (à échoir)"
                                    ]?.["Estimation suivante"]
                                  }
                                  form={formEstimationSuivante}
                                  onAddForm={onAddFormEstimationSuivante}
                                  onDeleteForm={onDeleteFormEstimationSuivante}
                                  handleInputChange={
                                    handleInputEstimationSuivanteChange
                                  }
                                  renderBaseOptions={renderBaseOptions()}
                                  renderOuiNonOptions={renderYesNoOptions()}
                                />
                              ) : null}
                              {factureData?.detail_fx_paiement?.["Extra"] ? (
                                <HmfFactureEdit
                                  title={"Extra"}
                                  data={
                                    factureData?.detail_fx_paiement?.[
                                      "Extra"
                                    ]?.["Extra"]
                                  }
                                  form={formExtra}
                                  onAddForm={onAddFormExtra}
                                  onDeleteForm={onDeleteFormExtra}
                                  handleInputChange={handleInputExtraChange}
                                  renderBaseOptions={renderBaseOptions()}
                                  renderOuiNonOptions={renderYesNoOptions()}
                                />
                              ) : null}
                              {Object.entries(
                                factureData?.detail_fx_paiement?.["Extra"]
                              ).map(([key, value], index) => (
                                <Row className="mb-2" key={index}>
                                  {key === "Extra only" ? (
                                    <>
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span
                                            style={{
                                              display: "inline-block",
                                              width: "11em",
                                              paddingTop: "10px",
                                            }}
                                          >
                                            {key} :
                                          </span>
                                        </i>
                                      </Col>
                                      <Col className="mb-2 col-md-8">
                                        <Select
                                          defaultValue={selectedExtra}
                                          onChange={handleExtraChange}
                                          options={renderOuiNonOptions()}
                                          isClearable={true}
                                          className="select2"
                                        />
                                      </Col>
                                    </>
                                  ) : null}
                                </Row>
                              ))}
                            </Col>
                            <Row>
                              <Col sm="12">
                                <CardTitle
                                  tag="h5"
                                  style={{ paddingBottom: "10px" }}
                                >
                                  Commentaire
                                </CardTitle>

                                <CardBody>
                                  <Editor
                                    apiKey="qtpzuvciq1zhh5k87yw2b2hoie40flpoqkafr142u8lfhp6i"
                                    onInit={(evt, editor) =>
                                      (editorRef.current = editor)
                                    }
                                    value={selectedCommentaire}
                                    init={{
                                      height: 1000,
                                      menubar: true,
                                      plugins: [
                                        "advlist",
                                        "autolink",
                                        "lists",
                                        "link",
                                        "image",
                                        "charmap",
                                        "preview",
                                        "anchor",
                                        "searchreplace",
                                        "visualblocks",
                                        "code",
                                        "fullscreen",
                                        "insertdatetime",
                                        "media",
                                        "table",
                                        "code",
                                        "help",
                                        "wordcount",
                                        "autosave",
                                      ],
                                      toolbar:
                                        "undo redo | blocks | " +
                                        "bold italic forecolor | alignleft aligncenter " +
                                        "alignright alignjustify | bullist numlist outdent indent | " +
                                        "removeformat | help",
                                      content_style:
                                        "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                                    }}
                                    onEditorChange={(content) => {
                                      setSelectedCommentaire(content);
                                    }}
                                  />
                                </CardBody>
                              </Col>
                            </Row>
                            <Col sm="12">{/*  */}</Col>
                          </Row>
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} setWait={wait} />
                      )}
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <ToastContainer />
    </React.Fragment>
  );
};

export default FactureEdit;
